export default __webpack_public_path__ + "static/media/pie_4.7b80e6c0.svg";